import React from 'react'
import Router from './router/routes'

function App() {
  return (
    <div>
      <Router />
    </div>
  )
}

export default App
